export default "__VITE_ASSET__f26a4971__"